import React, { useEffect, useState, useRef } from 'react';
import { updateSGF } from './ApiClient.js';
import { sgfStringToState } from './App';
const sgf = require('@sabaki/sgf')

export const DEFAULTKOMI=6.5

const GameInfo = ({ game, setGame, onClose }) => {

  const [hovered, setHovered] = useState(false);

  // Initialize state with game info
  const [gameData, setGameData] = useState({
    blackName: "",
    blackRank: "",
    whiteName: "",
    whiteRank: "",
    gameName: "",
    eventName: "",
    gameComment: "",
    date: "",
    result: "",
    komi: 0,
    handicap: 0,
    size: "",
    gameId: "",
    gameLength: 0,
  });

  // Populate fields 
  useEffect(() => {
    if (game && game.info) {
      setGameData(game.info);
    }
  }, [game]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGameData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  async function handleSave(e) {

    e.preventDefault();

    console.log("Saved Game Data:", gameData);

    // Generate new SGF content
    try {
      const newSgfContent = generateSGF(gameData);
      const updatedData = await updateSGF(gameData.gameId, newSgfContent);

    } catch (error) {
      console.error("Failed to update SGF:", error);
    } 

    // Update game info locally
    const newGame = {...game}; 
    newGame.info = gameData;
    setGame(newGame)
  };

  function generateSGF(gameData) {
    let myState = sgfStringToState(gameData.sgfString)
    let {gameTrees, gameIndex, gameCurrents} = myState
    let tree = gameTrees[gameIndex]

    console.log("before",tree)
    const rootId = tree.root.id;
    const newTree = tree.mutate(draft => {
      const properties = {
        "BR": gameData.blackRank,
        "WR": gameData.whiteRank,
        "DT": gameData.date,
        "PB": gameData.blackName,
        "PW": gameData.whiteName,
        "KM": gameData.komi,
        "GN": gameData.gameName,
        "RE": gameData.result,
        "PC": gameData.gameComment
      };
    
      Object.entries(properties).forEach(([key, value]) => {
        if (value != null) {
          draft.updateProperty(rootId, key, Array.isArray(value) ? value : [value]);
        }
      });
    });

    console.log("after",newTree)

    return sgf.stringify([newTree.root])
  }

  const hoveredRef = useRef(hovered); 

  useEffect(() => {
    hoveredRef.current = hovered;
  }, [hovered]);

  // Here we format game fields depending on what data was provided in game.info:
  let gameName = null
  let blackPlayer = 'Unknown'
  let whitePlayer = 'Unknown'
  let gameDetails = game.info.eventName
  let blackRank = game.info.blackRank ? ' ' + game.info.blackRank : ''
  let whiteRank = game.info.whiteRank ? ' ' + game.info.whiteRank : ''

  if(!!game.info.blackName)
    blackPlayer = game.info.blackName

  if(!!game.info.whiteName)
    whitePlayer = game.info.whiteName

  const altGameName = gameName = blackPlayer + blackRank + ' vs. ' + whitePlayer + whiteRank

  // Any click outside the menu closes it
  useEffect(() => {
      const handleClickOutside = (e) => {
      if (!e.target.closest(".game-info")) {
          onClose();
      }
      };

      document.addEventListener("click", handleClickOutside);
      return () => {
      document.removeEventListener("click", handleClickOutside);
      };
  }, []);

  // console.log(game.info)

      // let {
  //     playerNames,
  //     playerRanks,
  //     blackName,
  //     blackRank,
  //     whiteName,
  //     whiteRank,
  //     gameName,
  //     eventName,
  //     gameComment,
  //     date,
  //     result,
  //     komi,
  //     handicap,
  //     size, 
  //     gameId, 
  //     gameLength, 
  //   } = game; 


  return (
    <div className="dialog-box game-info">
      <div style="position: absolute; top: 20px; right: 20px; z-index: 10; display: flex; justify-content: flex-end;">
        <img 
            src="/icons/close.svg" 
            onClick={onClose}
            alt="Close game info"
            style="width: 20px; cursor: pointer; " />
        </div>
        <div>
        <form id="game-info-form" onSubmit={handleSave}>
          <div className="info-section">
            <h2>Players</h2>
            <div style="display:flex; flex-direction: row; justify-content: center">
            <div>
            <label>
              Black:
              <input
                type="text"
                name="blackName"
                value={gameData.blackName}
                onChange={handleInputChange}
              />
            </label>
            <label>
              Rank:
              <input
                type="text"
                name="blackRank"
                value={gameData.blackRank}
                onChange={handleInputChange}
              />
            </label>
            </div>
            <div>
            <label>
              White:
              <input
                type="text"
                name="whiteName"
                value={gameData.whiteName}
                onChange={handleInputChange}
              />
            </label>
            <label>
              Rank:
              <input
                type="text"
                name="whiteRank"
                value={gameData.whiteRank}
                onChange={handleInputChange}
              />
            </label>
            </div>
            </div>
          </div>

          <div className="info-section">
            <h2>Game Details</h2>
            <label>
              Game Name:
              <input
                type="text"
                name="gameName"
                value={gameData.gameName}
                onChange={handleInputChange}
              />
            </label>
            <label>
              Event Name:
              <input
                type="text"
                name="eventName"
                value={gameData.eventName}
                onChange={handleInputChange}
              />
            </label>
            <label>
              Comment:
              <textarea
                name="gameComment"
                value={gameData.gameComment}
                onChange={handleInputChange}
              />
            </label>
            <label>
              Date:
              <input
                type="date"
                name="date"
                value={gameData.date}
                onChange={handleInputChange}
              />
            </label>
            <label>
              Result:
              <input
                type="text"
                name="result"
                value={gameData.result}
                onChange={handleInputChange}
              />
            </label>
          </div>

          <div className="info-section">
            <h2>Game Settings</h2>
            <div style="display:flex; flex-direction: row; justify-content: left; gap: 15px;">
            <label>
              Komi:
              <input
                type="number"
                step="0.5"
                name="komi"
                value={gameData.komi ? gameData.komi : DEFAULTKOMI} // TODO make this a default komi set in preferences
                onChange={handleInputChange}
                style="width: 70px;"
              />
            </label>
            <label>
              Handicap:
              <input
                type="number"
                step="1"
                name="handicap"
                value={gameData.handicap}
                onChange={handleInputChange}
                style="width: 70px;"
              />
            </label>
            <label>
              Board Size:
              <span
                type="text"
                name="size"
              >{String(gameData.size[0]) +'x'+ String(gameData.size[1])}</span>
            </label>
            </div>
          </div>

          <div className="info-section">
            <h2>Other Information</h2>
            <div style="overflow: auto; display:flex; flex-direction: row; justify-content: left; gap: 10px;">
            <label style="white-space: nowrap;">
              Game Length:
              <span
                type="number"
                name="gameLength"
              >{gameData.gameLength}</span>
            </label>
            <label>
              Game ID:
              <span
                type="text"
                name="gameId"
                style="overflow: auto; flex: 0.8; margin-right: 20%;"
              >{gameData.gameId}</span>
            </label>
            </div>
          </div>

          <button type="submit">Save</button>
        </form>
      </div>
    </div>
  );
};

export default GameInfo;